import type { Vue } from 'vue/types/vue'
import { getCurrentInstance } from 'vue'

export interface EpbComposable {
  $epb: Vue['$epb']
}

export function useEpb(): EpbComposable {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $epb },
  } = ctx

  return {
    $epb,
  }
}
